import { useRoutes } from "react-router-dom";
import PublicRoute from "../components/route/PublicRoute.tsx";
import Register from "views/Register";
import AboutPage from "components/ui/About.tsx";
import PrivateRoute from "components/route/PrivateRoute.tsx";
import EnumeratorHomeLayout from "layout/Enumerator/index.tsx";
import Login from "views/Login/index.tsx";
import ForgotPassword from "views/ForgotPassword/index.tsx";
import RecruiterLayout from "layout/Recruiter/index.tsx";
import RecruiterHomePage from "layout/Recruiter/components/RecruiterHomePage.tsx";
import NotFound from "components/ui/NotFound.tsx";
import DefaultLayout from "layout/DefaultLayout/index.tsx";
import DefaultHomePage from "layout/DefaultLayout/components/DefaultHomePage.tsx";
import { RoleTypes } from "enum/role-type-enum.ts";
import OAuth2RedirectHandler from "oauth/index.tsx";
import EnumeratorProfileForm from "views/Profile/EnumeratorProfile/index.tsx";
import RecruiterProfile from "views/Profile/RecruiterProfile/index.tsx";
import JobDetails from "views/Jobs/JobDetails.tsx";
import MyJobs from "views/Jobs/MyJobs.tsx";
import Settings from "views/Settings/index.tsx";
import ChangePassword from "views/ChangePassword/index.tsx";
import Availibility from "views/Availability/index.tsx";
import PostJob from "views/PostJob/index.tsx";
import RecruiterJobList from "views/RecruiterJobList/index.tsx";
import RecruiterActivity from "views/RecruiterActivity/index.tsx";
import CandidatesList from "views/Candidates/index.tsx";
import Messages from "views/Messages/index.tsx";
import EnumeratorHomePage from "layout/Enumerator/components/EnumeratorHomePage.tsx";
import RecruiterDetails from "views/Profile/RecruiterProfile/components/RecruiterProfileDetails.tsx";
import EnumeratorDetails from "views/Profile/EnumeratorProfile/components/updateEnumeratorDetails.tsx";
import EnumeratorUpdateProfileForm from "views/Profile/EnumeratorProfile/UpdateProfile.tsx";
import ViewPage from "views/PostJob/components/ViewPage.tsx";
import TermsAndCondition from "views/TermsAndCondition/index.tsx";
import Dashboard from "views/Dashboard/index.tsx";

function MainRoutes() {
  const elements = useRoutes([
    {
      path: "/terms-conditions",
      element: <PublicRoute isRestricted={false} element={TermsAndCondition} />,
    },
    {
      path: "/register",
      element: <PublicRoute isRestricted={true} element={Register} />,
    },

    {
      path: "/oauth2/redirect",
      element: <PublicRoute isRestricted={false} element={OAuth2RedirectHandler} />,
    },
    {
      path: "/forgot-password",
      element: <PublicRoute isRestricted={true} element={ForgotPassword} />,
    },

    {
      path: "/login",
      element: <PublicRoute isRestricted={true} element={Login} />,
    },

    {
      path: "/",
      element: <PublicRoute isRestricted={true} element={DefaultLayout} />,
      children: [
        { path: "", element: <DefaultHomePage /> },
        {
          path: "about",
          element: <PublicRoute isRestricted={false} element={AboutPage} />,
        },
      ],
    },

    {
      path: "/enumerator",
      element: (
        <PrivateRoute element={EnumeratorHomeLayout} allowedRoles={[RoleTypes.ENUMERATOR]} />
      ),
      children: [
        {
          path: "home",
          element: <EnumeratorHomePage />,
        },
        {
          path: "profile/",
          element: <EnumeratorDetails />,
        },

        {
          path: "profile/update",
          element: <EnumeratorUpdateProfileForm />,
        }
        ,
        {
          path: "profile/cv/",
          element: <EnumeratorProfileForm />,
        },
        {
          path: "about",
          element: <AboutPage />,
        },
        {
          path: "job/details/:id",
          element: <JobDetails />,
        },
        {
          path: "settings/EnumeratorProfileForm",
          element: <Settings />,
        },
        {
          path: "myjobs",
          element: <MyJobs />
        },
        {
          path: "change-password",
          element: <ChangePassword />,
        },
        {
          path: "availibility",
          element: <Availibility />,
        },
        {
          path: "message",
          element: <Messages />,
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },

    {
      path: "/recruiter",
      element: <PrivateRoute element={RecruiterLayout} allowedRoles={[RoleTypes.RECRUITER]} />,
      children: [
        {
          path: "profile/:id",
          element: <RecruiterDetails />,
        },
        {
          path: "profile/update/:id",
          element: <RecruiterProfile />,
        },
         {
          path: "dashboard",
          element: <Dashboard />,
        },
        {
          path: "home",
          element: <RecruiterHomePage />,
        },
        {
          path: "post-job",
          element: <PostJob />,
        },
        {
          path: "update-job/:id",
          element: <PostJob />,
        },
        {
          path: "view-job/:id",
          element: <ViewPage />,
        },
        {
          path: "jobs",
          element: <RecruiterJobList />,
        },
        {
          path: "activity",
          element: <RecruiterActivity />,
        },
        {
          path: "candidates",
          element: <CandidatesList />,
        },
        {
          path: "message",
          element: <Messages />,
        },



        {
          path: "settings",
          element: <Settings />,
        },

        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
    //  {
    //     path: "details/enumerator/:id",
    //     element: <CandidateProfile (id) />,
    //   },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return elements;
}

export default MainRoutes;
